import { render, staticRenderFns } from "./PortalPopover.vue?vue&type=template&id=57b5ba24&"
import script from "./PortalPopover.vue?vue&type=script&lang=js&"
export * from "./PortalPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports